import dayjs from "dayjs";
import "dayjs/locale/nl";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);
dayjs.locale("nl");

export function fmtEuro(cents: number | null | undefined): string {
  if (cents == null) return "—";
  return "€" + (cents / 100).toFixed(2).replace(".", ",");
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  return dayjs(iso).format("D MMM YYYY");
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  return dayjs(iso).format("D MMM YYYY · HH:mm");
}

export function fmtRelative(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = dayjs(iso);
  if (Math.abs(d.diff(dayjs(), "day")) < 7) return d.fromNow();
  return d.format("D MMM HH:mm");
}

export function statusLabel(status: string): string {
  const map: Record<string, string> = {
    draft: "Concept",
    pending: "Wacht op betaling",
    paid: "Betaald",
    cancelled: "Geannuleerd",
    refunded: "Refund",
    invoice_sent: "Factuur verzonden",
    invoice_paid: "Factuur voldaan",
    issued: "Uitgegeven",
    sent: "Verzonden",
    scanned: "Gescand",
    void: "Geblokkeerd",
  };
  return map[status] ?? status;
}

export function emailStatusLabel(status: string): string {
  const map: Record<string, string> = {
    queued: "In wachtrij",
    sent: "Verzonden",
    delivered: "Afgeleverd",
    opened: "Geopend",
    clicked: "Geklikt",
    bounced: "Bounce",
    complained: "Klacht",
    failed: "Mislukt",
    retried: "Opnieuw verzonden",
  };
  return map[status] ?? status;
}

export function emailStatusClass(status: string): string {
  const map: Record<string, string> = {
    queued: "pending",
    sent: "pending",
    delivered: "paid",
    opened: "paid",
    clicked: "paid",
    bounced: "cancelled",
    complained: "cancelled",
    failed: "cancelled",
    retried: "sent",
  };
  return map[status] ?? "pending";
}

export function emailEventLabel(eventType: string): string {
  const map: Record<string, string> = {
    "email.sent": "Verzonden",
    "email.delivered": "Afgeleverd",
    "email.opened": "Geopend",
    "email.clicked": "Klik",
    "email.bounced": "Bounce",
    "email.complained": "Spam-klacht",
    "email.delivery_delayed": "Vertraagd",
    "email.failed": "Mislukt",
    "email.received": "Ontvangen",
  };
  return map[eventType] ?? eventType;
}

export function flowLabel(flow: string): string {
  const map: Record<string, string> = {
    regular: "Regulier",
    ambassador: "Ambassadeur",
    sponsor: "Sponsor",
  };
  return map[flow] ?? flow;
}
